import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';
import { StripeConnectStatus } from '@accounting/interfaces/stripe-connect-status';

export default class BPCStripeConnectService {
  protected $bpcApiRouteHelper: BPCApiRouteHelper;
  protected $bpcApi: typeof bpcApi;
  constructor() {
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
    this.$bpcApi = bpcApi;
  }

  async getStripeConnectStatus(): Promise<StripeConnectStatus> {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('stripe-connects')}/status`;
    const res = await this.$bpcApi.get(fetchEntityPath, null).toPromise();
    return res.data;
  }

  async getStripeConnectLink(): Promise<string> {
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('stripe-connects')}/url`;
    const res = await this.$bpcApi.get(fetchEntityPath, null).toPromise();
    return res.data;
  }

  async redirectStripeConnect() {
    const urlRedirect = await this.getStripeConnectLink();
    window.open(urlRedirect, '_blank');
  }
}
